import { Task } from "features/Resources/Task/models";
import { AutoFormSection } from "models/autoForm";
import NewHireAutoSaveForm from "features/Form/Components/NewHireAutoSaveForm";
import NewHireInputForm from "../../NewHireInputForm";

interface FormSchema {
  sections: AutoFormSection[];
}

const SELECT_BUDDY_FORM = {
  sections: [{
    title: "Select Buddy",
    fields: [
      {
        name: "buddyId",
        type: "userSelect",
        label: "Buddy",
        accessor: "buddyId",
        writer: "newHireJourney.buddyId",
      },
    ],
  }],
} as FormSchema;

export function SelectRoleTaskActionForm({ task }: { task: Task }) {
  return <NewHireInputForm task={task} formSchema={SELECT_BUDDY_FORM} />;
}

export function SelectRoleForm({ task, onSuccess }: { task: Task, onSuccess: (res: any) => void }) {
  return <NewHireAutoSaveForm formSchema={SELECT_BUDDY_FORM} newHireId={task?.newHireJourneyId} onSuccess={onSuccess} />;
}
